export default {"src":"/_next/static/media/mobile-user.58f9b715.svg","height":27,"width":27,"blurWidth":0,"blurHeight":0};